/**
 * @generated SignedSource<<adca74d32f73f7271291baa49b4dbf41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type StudentTargetFocusesFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  isActive: ActiveRecords;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  targetIds?: ReadonlyArray<string> | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type StudentTargetFocusesQuery$variables = {
  filter?: StudentTargetFocusesFilterInput | null | undefined;
};
export type StudentTargetFocusesQuery$data = {
  readonly studentTargetFocuses: ReadonlyArray<{
    readonly id: string;
    readonly isActive: boolean;
    readonly otherTargetsBlocked: boolean;
    readonly target: {
      readonly id: string;
      readonly targetGroup: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  }>;
};
export type StudentTargetFocusesQuery = {
  response: StudentTargetFocusesQuery$data;
  variables: StudentTargetFocusesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "studentTargetFocusesFilterInput",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentTargetFocusNode",
    "kind": "LinkedField",
    "name": "studentTargetFocuses",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otherTargetsBlocked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentTargetFocusesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentTargetFocusesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d79302aac2b3451100b3ca2721a003b2",
    "id": null,
    "metadata": {},
    "name": "StudentTargetFocusesQuery",
    "operationKind": "query",
    "text": "query StudentTargetFocusesQuery(\n  $filter: StudentTargetFocusesFilterInput\n) {\n  studentTargetFocuses(studentTargetFocusesFilterInput: $filter) {\n    id\n    isActive\n    otherTargetsBlocked\n    target {\n      id\n      targetGroup {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44ef952521ae211093af54e2142351e2";

export default node;
